// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  ENDPOINTS: {
    // Auth endpoints
    AUTH: '/api/auth',
    AUTH_VERIFY: '/api/auth/verify',
    AUTH_LOGIN: '/api/auth/login',
    AUTH_REGISTER: '/api/auth/register',

    // Pricing endpoints
    PRICING: '/api/pricing',
    PRICING_COMPANIES: '/api/pricing/companies',
    PRICING_MATRIX: (companyId: number) => `/api/pricing/matrix/${companyId}`,
    PRICING_BULK_IMPORT: '/api/pricing/bulk-import',
    PRICING_BULK_UPDATE: '/api/pricing/bulk-update',
    PRICING_CALCULATE: (companyId: number, fromStationId: number, toStationId: number) =>
      `/api/pricing/calculate/${companyId}/${fromStationId}/${toStationId}`,

    // Station endpoints
    STATIONS: '/api/stations',
    STATIONS_SEARCH: '/api/stations/search',
    STATIONS_BY_LINE: (lineId: number) => `/api/stations/line/${lineId}`,

    // Company endpoints
    COMPANIES: '/api/companies',
    COMPANIES_SEARCH: '/api/companies/search',
    COMPANIES_BY_REGION: (regionId: number) => `/api/companies/region/${regionId}`,

    // Line endpoints
    LINES: '/api/lines',
    LINES_SEARCH: '/api/lines/search',
    LINES_BY_COMPANY: (companyId: number) => `/api/lines/company/${companyId}`,

    // Region endpoints
    REGIONS: '/api/regions',

    // User endpoints
    USERS: '/api/users',
    USER_BY_ID: (userId: number) => `/api/users/${userId}`,
    USER_ROLES: (userId: number) => `/api/users/${userId}/roles`,
    USER_ROLE_DELETE: (userId: number, roleId: number) => `/api/users/${userId}/roles/${roleId}`,

    // Role endpoints
    ROLES: '/api/roles',
    ROLE_BY_ID: (roleId: number) => `/api/roles/${roleId}`,

    // Ticket endpoints
    TICKETS: '/api/booking/tickets/all',
    TICKET_BY_ID: (ticketId: number) => `/api/booking/tickets/${ticketId}`,
    TICKET_CANCEL: (ticketId: number) => `/api/booking/tickets/${ticketId}/cancel`,
    TICKET_UPDATE_STATUS: (ticketId: number, status: string) => `/api/booking/tickets/${ticketId}/update-status?new_status=${status}`,
    ADMIN_BOOK_TICKET: (userId: number) => `/api/booking/admin-book-ticket?user_id=${userId}`,

    // Validation endpoints
    VALIDATIONS: '/api/validation/all-validations',
    VALIDATION_BY_ID: (validationId: number) => `/api/validation/validations/${validationId}`,
    VALIDATION_UPDATE_STATUS: (validationId: number, status: string) => `/api/validation/validations/${validationId}/update-status?new_status=${status}`,

    // Route Management endpoints
    ROUTE_MANAGEMENT_ROUTES: '/api/route-management/routes',
    ROUTE_MANAGEMENT_ROUTE_BY_LINE: (lineId: number) => `/api/route-management/routes/line/${lineId}`,
    ROUTE_MANAGEMENT_SEGMENTS: (routeId: number) => `/api/route-management/routes/${routeId}/segments`,
    ROUTE_MANAGEMENT_SEGMENT_BY_ID: (segmentId: number) => `/api/route-management/segments/${segmentId}`,
    ROUTE_MANAGEMENT_SEGMENT_MOVE: (segmentId: number) => `/api/route-management/segments/${segmentId}/move`,

    // Intersection Management endpoints
    INTERSECTION_POINTS: '/api/intersection-management/points',
    INTERSECTION_POINT_BY_ID: (pointId: number) => `/api/intersection-management/points/${pointId}`,
    INTERSECTION_SEGMENTS: '/api/intersection-management/segments',
    INTERSECTION_SEGMENT_BY_ID: (segmentId: number) => `/api/intersection-management/segments/${segmentId}`,

    // Transit Route endpoints
    TRANSIT_ROUTES: '/api/transit-routes',
    TRANSIT_ROUTE_BY_ID: (routeId: number) => `/api/transit-routes/${routeId}`,

    // Unified Route endpoints
    UNIFIED_ROUTES: '/api/unified-routes',
    UNIFIED_ROUTE_BY_ID: (routeId: number) => `/api/unified-routes/${routeId}`,

    // Pathfinding endpoints
    PATHFINDING_SHORTEST_PATH: '/api/pathfinding/shortest-path',

    // Multi-segment Route endpoints
    MULTI_SEGMENT_ROUTES: '/api/multi-segment-routes',
    MULTI_SEGMENT_ROUTE_BY_ID: (routeId: number) => `/api/multi-segment-routes/${routeId}`
  }
};

// Helper function to build full URL
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function for common fetch operations
export const apiRequest = async (endpoint: string, options: RequestInit = {}) => {
  const url = buildApiUrl(endpoint);
  const defaultOptions: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  return fetch(url, defaultOptions);
};

export default API_CONFIG;